import React from 'react';

export const SectionLabel = ({ children, light = false }) => (
  <div className="flex items-center gap-4 justify-center mb-5">
    <span className={`divider-gold ${light ? 'bg-gold/60' : ''}`} />
    <span className={`text-xs tracking-[0.3em] uppercase font-medium ${light ? 'text-gold/80' : 'text-gold'}`}>
      {children}
    </span>
    <span className={`divider-gold ${light ? 'bg-gold/60' : ''}`} />
  </div>
);